import { render, staticRenderFns } from "./VxHeadCellSelectableCheckbox.vue?vue&type=template&id=1bceb1f4&"
import script from "./VxHeadCellSelectableCheckbox.vue?vue&type=script&lang=js&"
export * from "./VxHeadCellSelectableCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports